/* eslint-disable */
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'



//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = store.state.server;
if (new RegExp(["localhost", "dev.", "sandbox"].join("|")).test(location.host)) {
  axios.defaults.baseURL = "https://dmb-fiesta.dev.doubledot.es/";
}
//.AXIOS

//VEE-VALIDATE
import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';
Validator.localize('es', validatorEs);
Vue.use(VeeValidate,{
	locale : 'es',
	dictionary: {
		es : {messages : validatorEs}
	}
});
//.VEE-VALIDATE




//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from './translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: store.state.language,
	messages,
});
//.IDIOMAS


// GOOGLE MAPS

import * as VueGoogleMaps from 'vue2-google-maps'


Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyDEyOEKVWunzgL0iI_aUFfWQBReR-Xp9xY',
	},
});

Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	i18n,
	store,
	VeeValidate,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js